import { render, staticRenderFns } from "./ReportsComparative.vue?vue&type=template&id=2bf84d4b&scoped=true&"
import script from "./ReportsComparative.vue?vue&type=script&lang=js&"
export * from "./ReportsComparative.vue?vue&type=script&lang=js&"
import style0 from "./ReportsComparative.vue?vue&type=style&index=0&id=2bf84d4b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf84d4b",
  null
  
)

export default component.exports